export enum ProviderUserStatusType {
  Invited = 0,
  Accepted = 1,
  Confirmed = 2,
  Deactivated = -1, // Not used, compile-time support only
}
